import { ApiKey } from "../../common/request/apiKey";
import { useApiTrigger } from "../../common/request/useApiTrigger";
import {
  OrderForDeliveryWithDddAuthenticationRequest,
  OrderForDeliveryWithDddAuthenticationResponse,
} from "./types";

export const useOrderForDeliveryWithDDDAuthenticationTrigger = () => {
  return useApiTrigger<
    OrderForDeliveryWithDddAuthenticationResponse,
    OrderForDeliveryWithDddAuthenticationRequest
  >({
    method: ApiKey.ORDER_FOR_DELIVERY_WITH_DDD_AUTHENTICATION,
  });
};
